import module from 'empresa/module.js'

export const schema = {
  proveedor_id: 'number',
}

export default class EmpresaCatalogoProveedorFacturacionService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/empresa/catalogo/proveedor_facturacion', {
      schema,
    })
  }
}

module.service('EmpresaCatalogoProveedorFacturacion', EmpresaCatalogoProveedorFacturacionService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Catalogo/ProveedorFacturacion.js